module.exports = __webpack_public_path__ + "img/the-girl-who-fell-beneath-the-sea.066d7798.png";